<div class="page-wrapper">
    <div class="d-flex justify-content-between align-items-start mb-4 gap-3 flex-wrap">
        <div class="d-flex gap-3 align-items-center">

            <H4 style="font-size: 18px; font-weight: bolder">OVERVIEW</H4>
        </div>


        <div class="filter">
            <div class="item" [ngClass]="{'active': activePeriodFilter == 'TODAY'}"
                (click)="setActiveFilter({period: 'TODAY'})">
                Today
            </div>
            <div class="item" [ngClass]="{'active': activePeriodFilter == 'WEEK'}"
                (click)="setActiveFilter({period: 'WEEK'})">
                Week
            </div>
            <div class="item" [ngClass]="{'active': activePeriodFilter == 'MONTH'}"
                (click)="setActiveFilter({period: 'MONTH'})">
                Month
            </div>
            <div class="item" [ngClass]="{'active': activePeriodFilter == 'YEAR'}"
                (click)="setActiveFilter({period:'YEAR'})">
                Year
            </div>



            <div class="item date-filter">

                <div class="toggle" role="button" (click)="picker.open()">
                    <svg width="11" height="11" viewBox="0 0 11 11" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M8.67174 1.70312H1.67186C1.11958 1.70312 0.671875 2.10606 0.671875 2.60311V8.903C0.671875 9.40005 1.11958 9.80298 1.67186 9.80298H8.67174C9.22401 9.80298 9.67172 9.40005 9.67172 8.903V2.60311C9.67172 2.10606 9.22401 1.70312 8.67174 1.70312Z"
                            stroke="#6B6C7E" stroke-width="0.8" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M7.17188 0.803711V2.60368" stroke="#6B6C7E" stroke-width="0.8"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M3.17188 0.803711V2.60368" stroke="#6B6C7E" stroke-width="0.8"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M0.671875 4.4043H9.67172" stroke="#6B6C7E" stroke-width="0.8"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>


                    <span class="current-filter">
                        {{formatActiveFilterTitle(activePeriodFilter)}}
                    </span>

                    <svg width="10" height="6" viewBox="0 0 10 6" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M8.67188 0.803711L4.86032 4.72335C4.83559 4.74883 4.80621 4.76904 4.77388 4.78283C4.74154 4.79661 4.70688 4.80371 4.67188 4.80371C4.63687 4.80371 4.60221 4.79661 4.56987 4.78283C4.53754 4.76904 4.50816 4.74883 4.48343 4.72335L0.671875 0.803711"
                            stroke="#071655" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>

                </div>

                <mat-form-field>
                    <mat-date-range-input [dateFilter]="dateRangeFilter" [formGroup]="rangePickerForm"
                        [rangePicker]="picker" #rangeInput>
                        <input matStartDate placeholder="Start date" formControlName="startDate">
                        <input matEndDate placeholder="End date" formControlName="endDate">
                    </mat-date-range-input>

                    <!-- <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle> -->
                </mat-form-field>
                <mat-date-range-picker #picker (closed)="onDateChange($event)"> </mat-date-range-picker>
                <app-error-message [form]="rangePickerForm" controlName="endDate"></app-error-message>

                
            </div>
        </div>
    </div>

    <div class="asset-dashboard-cards">
        <div class="asset-dashboard-card asset-dashboard-card-2"
            style="background-image: url('./assets/images/dashboard-card-green-with-curves.jpg'); background-color: #00B040;">


            <div class="content">

                <div class="top">
                    <span class="title text-white">
                        Total Assets
                    </span>
                </div>

                <div class="card-value text-white">
                    <div class="icon">
                        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_10615_11343)">
                                <path
                                    d="M7.375 7.84668V18.0842L8.32375 14.8554H13.8925V7.84668H7.375ZM9.205 13.5579C9.205 13.7642 9.03625 13.9329 8.83 13.9329C8.62375 13.9329 8.455 13.7642 8.455 13.5579V13.2354C8.455 13.0292 8.62 12.8604 8.83 12.8604C9.04 12.8604 9.205 13.0292 9.205 13.2354V13.5579ZM9.205 11.6942C9.205 11.9004 9.03625 12.0692 8.83 12.0692C8.62375 12.0692 8.455 11.9004 8.455 11.6942V11.3717C8.455 11.1617 8.62 10.9967 8.83 10.9967C9.04 10.9967 9.205 11.1617 9.205 11.3717V11.6942ZM9.205 9.82668C9.205 10.0367 9.03625 10.2017 8.83 10.2017C8.62375 10.2017 8.455 10.0367 8.455 9.82668V9.50418C8.455 9.29793 8.62 9.12918 8.83 9.12918C9.04 9.12918 9.205 9.29793 9.205 9.50418V9.82668ZM11.0087 13.5579C11.0087 13.7642 10.84 13.9329 10.6337 13.9329C10.4275 13.9329 10.2587 13.7642 10.2587 13.5579V13.2354C10.2587 13.0292 10.4275 12.8604 10.6337 12.8604C10.84 12.8604 11.0087 13.0292 11.0087 13.2354V13.5579ZM11.0087 11.6942C11.0087 11.9004 10.84 12.0692 10.6337 12.0692C10.4275 12.0692 10.2587 11.9004 10.2587 11.6942V11.3717C10.2587 11.1617 10.4275 10.9967 10.6337 10.9967C10.84 10.9967 11.0087 11.1617 11.0087 11.3717V11.6942ZM11.0087 9.82668C11.0087 10.0367 10.84 10.2017 10.6337 10.2017C10.4275 10.2017 10.2587 10.0367 10.2587 9.82668V9.50418C10.2587 9.29793 10.4275 9.12918 10.6337 9.12918C10.84 9.12918 11.0087 9.29793 11.0087 9.50418V9.82668ZM12.8162 13.5579C12.8162 13.7642 12.6475 13.9329 12.4412 13.9329C12.235 13.9329 12.0662 13.7642 12.0662 13.5579V13.2354C12.0662 13.0292 12.2313 12.8604 12.4412 12.8604C12.6512 12.8604 12.8162 13.0292 12.8162 13.2354V13.5579ZM12.8162 11.6942C12.8162 11.9004 12.6475 12.0692 12.4412 12.0692C12.235 12.0692 12.0662 11.9004 12.0662 11.6942V11.3717C12.0662 11.1617 12.2313 10.9967 12.4412 10.9967C12.6512 10.9967 12.8162 11.1617 12.8162 11.3717V11.6942ZM12.8162 9.82668C12.8162 10.0367 12.6475 10.2017 12.4412 10.2017C12.235 10.2017 12.0662 10.0367 12.0662 9.82668V9.50418C12.0662 9.29793 12.2313 9.12918 12.4412 9.12918C12.6512 9.12918 12.8162 9.29793 12.8162 9.50418V9.82668Z"
                                    fill="#045C07" />
                                <path
                                    d="M22.9094 0.729492L18.9156 1.52824L19.8456 2.46199L16.3619 5.94574L13.6994 3.28324L11.7344 5.51449L12.9269 6.70699L13.6994 5.94574L16.4969 8.47324L21.1769 3.79324L22.1106 4.72324L22.9094 0.729492Z"
                                    fill="#045C07" />
                                <path
                                    d="M7.40406 7.08203V6.33203H9.26031V5.95703H4.72656V9.84203H6.62031V9.79328V7.84703V7.62203V7.08203"
                                    fill="#045C07" />
                                <path d="M8.15625 7.10059H13.1063V7.86559H8.15625V7.10059Z" fill="#045C07" />
                                <path d="M16.5984 23.271H11.1797L12.3047 19.4385H15.4734L16.5984 23.271Z"
                                    fill="#045C07" />
                                <path d="M16.2266 19.4385H22.3278L23.4528 23.271H17.3516L16.2266 19.4385Z"
                                    fill="#045C07" />
                                <path
                                    d="M1.28906 10.6143V23.2743H4.97906L5.72531 20.7355C5.66906 20.7693 5.59781 20.7918 5.52656 20.7918H2.48156C2.27156 20.7918 2.10656 20.623 2.10656 20.4168C2.10656 20.2105 2.27156 20.0418 2.48156 20.0418H5.52656C5.67656 20.0418 5.80781 20.1318 5.86406 20.2593L6.32531 18.688H6.64406V10.6143H1.28906ZM5.52656 19.2093H2.48156C2.27156 19.2093 2.10656 19.0405 2.10656 18.8343C2.10656 18.628 2.27156 18.4593 2.48156 18.4593H5.52656C5.73281 18.4593 5.90156 18.628 5.90156 18.8343C5.90156 19.0405 5.73281 19.2093 5.52656 19.2093ZM5.52656 17.6268H2.48156C2.27156 17.6268 2.10656 17.458 2.10656 17.2518C2.10656 17.0455 2.27156 16.8768 2.48156 16.8768H5.52656C5.73281 16.8768 5.90156 17.0418 5.90156 17.2518C5.90156 17.4618 5.73281 17.6268 5.52656 17.6268ZM5.52656 16.0405H2.48156C2.27156 16.0405 2.10656 15.8755 2.10656 15.6655C2.10656 15.4555 2.27156 15.2905 2.48156 15.2905H5.52656C5.73281 15.2905 5.90156 15.4593 5.90156 15.6655C5.90156 15.8718 5.73281 16.0405 5.52656 16.0405ZM5.52656 14.458H2.48156C2.27156 14.458 2.10656 14.2893 2.10656 14.083C2.10656 13.8768 2.27156 13.708 2.48156 13.708H5.52656C5.73281 13.708 5.90156 13.8768 5.90156 14.083C5.90156 14.2893 5.73281 14.458 5.52656 14.458ZM5.52656 12.8755H2.48156C2.27156 12.8755 2.10656 12.7068 2.10656 12.5005C2.10656 12.2943 2.27156 12.1255 2.48156 12.1255H5.52656C5.73281 12.1255 5.90156 12.2943 5.90156 12.5005C5.90156 12.7068 5.73281 12.8755 5.52656 12.8755Z"
                                    fill="#045C07" />
                                <path d="M8.87844 15.6055H12.0509L12.9097 18.5305H8.02344L8.87844 15.6055Z"
                                    fill="#045C07" />
                                <path
                                    d="M20.5219 18.5305H13.6556L12.7969 15.6055H16.0444C16.9144 16.4005 18.0694 16.888 19.3369 16.888C19.5694 16.888 19.7981 16.873 20.0231 16.8392L20.5219 18.5305Z"
                                    fill="#045C07" />
                                <path d="M11.1844 23.271H5.76562L6.89062 19.4385H10.0594L11.1844 23.271Z"
                                    fill="#045C07" />
                                <path
                                    d="M19.3362 7.90332C17.0637 7.90332 15.2188 9.74457 15.2188 12.0208C15.2188 14.2971 17.0637 16.1383 19.3362 16.1383C21.6087 16.1383 23.4537 14.2971 23.4537 12.0208C23.4537 9.74457 21.6125 7.90332 19.3362 7.90332ZM19.3362 15.0096C17.6862 15.0096 16.3475 13.6708 16.3475 12.0208C16.3475 10.3708 17.6862 9.03207 19.3362 9.03207C20.9862 9.03207 22.325 10.3708 22.325 12.0208C22.325 13.6708 20.9862 15.0096 19.3362 15.0096Z"
                                    fill="#045C07" />
                                <path
                                    d="M19.3353 13.7827C18.7053 13.7827 18.1953 13.2727 18.1953 12.6427C18.1953 12.4364 18.3641 12.2677 18.5703 12.2677C18.7766 12.2677 18.9453 12.4364 18.9453 12.6427C18.9453 12.8489 19.1216 13.0327 19.3353 13.0327C19.5491 13.0327 19.7253 12.8564 19.7253 12.6427C19.7253 12.4289 19.5491 12.2527 19.3353 12.2527C18.7053 12.2527 18.1953 11.7427 18.1953 11.1127C18.1953 10.4827 18.7053 9.97266 19.3353 9.97266C19.9653 9.97266 20.4753 10.4827 20.4753 11.1127C20.4753 11.3189 20.3066 11.4877 20.1003 11.4877C19.8941 11.4877 19.7253 11.3189 19.7253 11.1127C19.7253 10.9064 19.5491 10.7227 19.3353 10.7227C19.1216 10.7227 18.9453 10.8989 18.9453 11.1127C18.9453 11.3264 19.1216 11.5027 19.3353 11.5027C19.9653 11.5027 20.4753 12.0127 20.4753 12.6427C20.4753 13.2727 19.9653 13.7827 19.3353 13.7827Z"
                                    fill="#045C07" />
                                <path
                                    d="M19.3359 10.7229C19.1297 10.7229 18.9609 10.5541 18.9609 10.3479V9.83789C18.9609 9.63164 19.1297 9.46289 19.3359 9.46289C19.5422 9.46289 19.7109 9.63164 19.7109 9.83789V10.3479C19.7109 10.5541 19.5422 10.7229 19.3359 10.7229Z"
                                    fill="#045C07" />
                                <path
                                    d="M19.3359 14.2971C19.1297 14.2971 18.9609 14.1284 18.9609 13.9221V13.4121C18.9609 13.2059 19.1297 13.0371 19.3359 13.0371C19.5422 13.0371 19.7109 13.2059 19.7109 13.4121V13.9221C19.7109 14.1284 19.5422 14.2971 19.3359 14.2971Z"
                                    fill="#045C07" />
                            </g>
                            <defs>
                                <clipPath id="clip0_10615_11343">
                                    <rect width="24" height="24" fill="white"
                                        transform="translate(0.203125 0.0205078)" />
                                </clipPath>
                            </defs>
                        </svg>
                    </div>

                    @if(assetCount){
                    <p class="value text-white">{{assetCount?.transport + assetCount?.property + assetCount?.market }}
                    </p>
                    }
                    @else {
                    <span class="spinner-light"></span>
                    }
                </div>

            </div>
        </div>



        <div class="asset-dashboard-card asset-dashboard-card-2"
            style="background-image: url('./assets/images/dashboard-card-white-with-curves.jpg'); background-color: #fff;">



            <div class="content">

                <div class="top">
                    <span class="title">
                        Total Transport Assets
                    </span>

                    <button (click)="goToSummary('transport')">See More
                        <svg width="8" height="8" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M0.6875 3.24121L3.0246 0.904113L0.6875 3.24121Z" fill="#02632A" />
                            <path d="M0.6875 3.24121L3.0246 0.904113" stroke="#02632A" stroke-width="0.46742"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M0.6875 0.904113H3.0246V3.24121" stroke="#02632A" stroke-width="0.46742"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </button>
                </div>

                <div class="card-value">
                    <div class="icon">
                        <svg width="28" height="20" viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M14.5124 12.0151H27.8125V18.4636C27.8125 19.1314 27.2712 19.6727 26.6034 19.6727H24.9913C24.3235 19.6727 23.7822 19.1314 23.7822 18.4636V17.6576H18.5427V18.4636C18.5427 19.1314 18.0014 19.6727 17.3336 19.6727H15.7215C15.0537 19.6727 14.5124 19.1314 14.5124 18.4636V12.0151ZM22.5731 14.0303H19.7518C19.3067 14.0303 18.9458 14.3912 18.9458 14.8363C18.9458 15.2815 19.3067 15.6424 19.7518 15.6424H22.5731C23.0182 15.6424 23.3791 15.2815 23.3791 14.8363C23.3791 14.3912 23.0182 14.0303 22.5731 14.0303ZM17.3336 14.0303H16.9306C16.4854 14.0303 16.1245 14.3912 16.1245 14.8363C16.1245 15.2815 16.4854 15.6424 16.9306 15.6424H17.3336C17.7788 15.6424 18.1397 15.2815 18.1397 14.8363C18.1397 14.3912 17.7788 14.0303 17.3336 14.0303ZM25.3943 14.0303H24.9913C24.5461 14.0303 24.1852 14.3912 24.1852 14.8363C24.1852 15.2815 24.5461 15.6424 24.9913 15.6424H25.3943C25.8395 15.6424 26.2004 15.2815 26.2004 14.8363C26.2004 14.3912 25.8395 14.0303 25.3943 14.0303ZM14.7811 10.403L16.5896 6.0626C16.7147 5.76222 17.0082 5.56658 17.3336 5.56658H24.9913C25.3167 5.56658 25.6102 5.76222 25.7353 6.0626L27.5438 10.403H14.7811ZM7.25781 18.4636C7.25781 19.1314 6.71648 19.6727 6.04871 19.6727H4.03355C3.36578 19.6727 2.82445 19.1314 2.82445 18.4636V12.0151H12.9003V17.6576H7.25781V18.4636ZM10.8851 14.0303H8.86994C8.42477 14.0303 8.06388 14.3912 8.06388 14.8363C8.06388 15.2815 8.42477 15.6424 8.86994 15.6424H10.8851C11.3303 15.6424 11.6912 15.2815 11.6912 14.8363C11.6912 14.3912 11.3303 14.0303 10.8851 14.0303ZM6.04871 14.0303H5.64568C5.2005 14.0303 4.83961 14.3912 4.83961 14.8363C4.83961 15.2815 5.2005 15.6424 5.64568 15.6424H6.04871C6.49389 15.6424 6.85478 15.2815 6.85478 14.8363C6.85478 14.3912 6.49389 14.0303 6.04871 14.0303ZM15.7215 4.57016C15.4574 4.80627 15.2434 5.10197 15.1015 5.44255L13.0346 10.403H2.82445V5.96961C2.37927 5.96961 2.01838 6.3305 2.01838 6.77568V9.19388C2.01838 9.63906 1.65749 9.99994 1.21232 9.99994C0.767138 9.99994 0.40625 9.63906 0.40625 9.19388V6.77568C0.40625 5.44014 1.48891 4.35748 2.82445 4.35748H15.7215V4.57016ZM4.43658 0.327148H14.1094C14.9997 0.327148 15.7215 1.04892 15.7215 1.93928V2.74535H2.82445V1.93928C2.82445 1.04892 3.54622 0.327148 4.43658 0.327148Z"
                                fill="#045C07" />
                        </svg>


                    </div>

                    @if(assetCount){
                    <p class="value">{{assetCount?.transport }}</p>
                    }
                    @else {
                    <span class="spinner-light"></span>
                    }
                </div>

            </div>
        </div>


        <div class="asset-dashboard-card asset-dashboard-card-2"
            style="background-image: url('./assets/images/dashboard-card-white-with-curves.jpg'); background-color: #fff;">



            <div class="content">

                <div class="top">
                    <span class="title">
                        Total Market Assets
                    </span>

                    <button (click)="goToSummary('market')">See More
                        <svg width="8" height="8" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M0.6875 3.24121L3.0246 0.904113L0.6875 3.24121Z" fill="#02632A" />
                            <path d="M0.6875 3.24121L3.0246 0.904113" stroke="#02632A" stroke-width="0.46742"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M0.6875 0.904113H3.0246V3.24121" stroke="#02632A" stroke-width="0.46742"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </button>
                </div>

                <div class="card-value">
                    <div class="icon">
                        <svg width="28" height="20" viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M14.5124 12.0151H27.8125V18.4636C27.8125 19.1314 27.2712 19.6727 26.6034 19.6727H24.9913C24.3235 19.6727 23.7822 19.1314 23.7822 18.4636V17.6576H18.5427V18.4636C18.5427 19.1314 18.0014 19.6727 17.3336 19.6727H15.7215C15.0537 19.6727 14.5124 19.1314 14.5124 18.4636V12.0151ZM22.5731 14.0303H19.7518C19.3067 14.0303 18.9458 14.3912 18.9458 14.8363C18.9458 15.2815 19.3067 15.6424 19.7518 15.6424H22.5731C23.0182 15.6424 23.3791 15.2815 23.3791 14.8363C23.3791 14.3912 23.0182 14.0303 22.5731 14.0303ZM17.3336 14.0303H16.9306C16.4854 14.0303 16.1245 14.3912 16.1245 14.8363C16.1245 15.2815 16.4854 15.6424 16.9306 15.6424H17.3336C17.7788 15.6424 18.1397 15.2815 18.1397 14.8363C18.1397 14.3912 17.7788 14.0303 17.3336 14.0303ZM25.3943 14.0303H24.9913C24.5461 14.0303 24.1852 14.3912 24.1852 14.8363C24.1852 15.2815 24.5461 15.6424 24.9913 15.6424H25.3943C25.8395 15.6424 26.2004 15.2815 26.2004 14.8363C26.2004 14.3912 25.8395 14.0303 25.3943 14.0303ZM14.7811 10.403L16.5896 6.0626C16.7147 5.76222 17.0082 5.56658 17.3336 5.56658H24.9913C25.3167 5.56658 25.6102 5.76222 25.7353 6.0626L27.5438 10.403H14.7811ZM7.25781 18.4636C7.25781 19.1314 6.71648 19.6727 6.04871 19.6727H4.03355C3.36578 19.6727 2.82445 19.1314 2.82445 18.4636V12.0151H12.9003V17.6576H7.25781V18.4636ZM10.8851 14.0303H8.86994C8.42477 14.0303 8.06388 14.3912 8.06388 14.8363C8.06388 15.2815 8.42477 15.6424 8.86994 15.6424H10.8851C11.3303 15.6424 11.6912 15.2815 11.6912 14.8363C11.6912 14.3912 11.3303 14.0303 10.8851 14.0303ZM6.04871 14.0303H5.64568C5.2005 14.0303 4.83961 14.3912 4.83961 14.8363C4.83961 15.2815 5.2005 15.6424 5.64568 15.6424H6.04871C6.49389 15.6424 6.85478 15.2815 6.85478 14.8363C6.85478 14.3912 6.49389 14.0303 6.04871 14.0303ZM15.7215 4.57016C15.4574 4.80627 15.2434 5.10197 15.1015 5.44255L13.0346 10.403H2.82445V5.96961C2.37927 5.96961 2.01838 6.3305 2.01838 6.77568V9.19388C2.01838 9.63906 1.65749 9.99994 1.21232 9.99994C0.767138 9.99994 0.40625 9.63906 0.40625 9.19388V6.77568C0.40625 5.44014 1.48891 4.35748 2.82445 4.35748H15.7215V4.57016ZM4.43658 0.327148H14.1094C14.9997 0.327148 15.7215 1.04892 15.7215 1.93928V2.74535H2.82445V1.93928C2.82445 1.04892 3.54622 0.327148 4.43658 0.327148Z"
                                fill="#045C07" />
                        </svg>


                    </div>

                    @if(assetCount){
                    <p class="value">{{assetCount?.market }}</p>
                    }
                    @else {
                    <span class="spinner-light"></span>
                    }
                </div>

            </div>
        </div>

        <div class="asset-dashboard-card asset-dashboard-card-2"
            style="background-image: url('./assets/images/dashboard-card-white-with-curves.jpg'); background-color: #fff;">



            <div class="content">

                <div class="top">
                    <span class="title">
                        Total Property Asset
                    </span>

                    <button (click)="goToSummary('property')">See More
                        <svg width="8" height="8" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M0.6875 3.24121L3.0246 0.904113L0.6875 3.24121Z" fill="#02632A" />
                            <path d="M0.6875 3.24121L3.0246 0.904113" stroke="#02632A" stroke-width="0.46742"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M0.6875 0.904113H3.0246V3.24121" stroke="#02632A" stroke-width="0.46742"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </button>
                </div>

                <div class="card-value">
                    <div class="icon">
                        <svg width="28" height="20" viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M14.5124 12.0151H27.8125V18.4636C27.8125 19.1314 27.2712 19.6727 26.6034 19.6727H24.9913C24.3235 19.6727 23.7822 19.1314 23.7822 18.4636V17.6576H18.5427V18.4636C18.5427 19.1314 18.0014 19.6727 17.3336 19.6727H15.7215C15.0537 19.6727 14.5124 19.1314 14.5124 18.4636V12.0151ZM22.5731 14.0303H19.7518C19.3067 14.0303 18.9458 14.3912 18.9458 14.8363C18.9458 15.2815 19.3067 15.6424 19.7518 15.6424H22.5731C23.0182 15.6424 23.3791 15.2815 23.3791 14.8363C23.3791 14.3912 23.0182 14.0303 22.5731 14.0303ZM17.3336 14.0303H16.9306C16.4854 14.0303 16.1245 14.3912 16.1245 14.8363C16.1245 15.2815 16.4854 15.6424 16.9306 15.6424H17.3336C17.7788 15.6424 18.1397 15.2815 18.1397 14.8363C18.1397 14.3912 17.7788 14.0303 17.3336 14.0303ZM25.3943 14.0303H24.9913C24.5461 14.0303 24.1852 14.3912 24.1852 14.8363C24.1852 15.2815 24.5461 15.6424 24.9913 15.6424H25.3943C25.8395 15.6424 26.2004 15.2815 26.2004 14.8363C26.2004 14.3912 25.8395 14.0303 25.3943 14.0303ZM14.7811 10.403L16.5896 6.0626C16.7147 5.76222 17.0082 5.56658 17.3336 5.56658H24.9913C25.3167 5.56658 25.6102 5.76222 25.7353 6.0626L27.5438 10.403H14.7811ZM7.25781 18.4636C7.25781 19.1314 6.71648 19.6727 6.04871 19.6727H4.03355C3.36578 19.6727 2.82445 19.1314 2.82445 18.4636V12.0151H12.9003V17.6576H7.25781V18.4636ZM10.8851 14.0303H8.86994C8.42477 14.0303 8.06388 14.3912 8.06388 14.8363C8.06388 15.2815 8.42477 15.6424 8.86994 15.6424H10.8851C11.3303 15.6424 11.6912 15.2815 11.6912 14.8363C11.6912 14.3912 11.3303 14.0303 10.8851 14.0303ZM6.04871 14.0303H5.64568C5.2005 14.0303 4.83961 14.3912 4.83961 14.8363C4.83961 15.2815 5.2005 15.6424 5.64568 15.6424H6.04871C6.49389 15.6424 6.85478 15.2815 6.85478 14.8363C6.85478 14.3912 6.49389 14.0303 6.04871 14.0303ZM15.7215 4.57016C15.4574 4.80627 15.2434 5.10197 15.1015 5.44255L13.0346 10.403H2.82445V5.96961C2.37927 5.96961 2.01838 6.3305 2.01838 6.77568V9.19388C2.01838 9.63906 1.65749 9.99994 1.21232 9.99994C0.767138 9.99994 0.40625 9.63906 0.40625 9.19388V6.77568C0.40625 5.44014 1.48891 4.35748 2.82445 4.35748H15.7215V4.57016ZM4.43658 0.327148H14.1094C14.9997 0.327148 15.7215 1.04892 15.7215 1.93928V2.74535H2.82445V1.93928C2.82445 1.04892 3.54622 0.327148 4.43658 0.327148Z"
                                fill="#045C07" />
                        </svg>


                    </div>

                    @if(assetCount){
                    <p class="value">{{assetCount?.property }}</p>
                    }
                    @else {
                    <span class="spinner-light"></span>
                    }
                </div>

            </div>
        </div>



    </div>



    <div class="asset-chart-wrapper">

        <div class="top">
            <div class="asset-chart-header">
                <div class="title"><span class="title">Total Assets:</span> <span class="value">{{ totalAssetCount || '--' | number }}</span></div>

            </div>
        </div>


        <div class="graph mt-3">
            <ngx-charts-bar-vertical-2d [scheme]="barChartColorScheme" [results]="barChartData" [gradient]="gradient"
                [xAxis]="showXAxis" [yAxis]="showYAxis" [legend]="showLegend" [legendTitle]="null"
                [legendPosition]="legendPosition.Below" (select)="onSelect($event)">
            </ngx-charts-bar-vertical-2d>
        </div>


    </div>



</div>

<!-- <app-bounce-loader></app-bounce-loader> -->